module.exports = __webpack_public_path__ + "img/price-tag-fill.c883ef91.svg";